export default __webpack_public_path__ + "static/media/misc002.cb7b19f4.jpeg";